import React from 'react';

import { FlexCol, FlexRow, TitleSmall } from '../../../common/components/v2';
import { DocumentType } from '../../../common/constants/documentType';
import { Resource } from '../../../common/constants/resource';
import { TaskState } from '../../../common/constants/states';
import ElementLocators from '../../../common/ElementLocators';
import { evidenceExists, getFormattedTimestamp } from '../../../common/helpers';
import { ITask } from '../../tasks/interfaces/ITask';
import styles from '../styles.module.scss';
import { FileDetail } from './components/FileDetail';
import { FileUpload } from './components/FileUpload';
import { NoraTaskIcon } from './components/NoraTaskIcon';

export const ReinstatementDetail = ({
  task,
  uploadHandler,
  downloadHandler,
  taskStateHandler,
  deleteHandler,
}: {
  task: ITask;
  uploadHandler: (
    existingTaskData: ITask,
    data: FormData,
    type: string,
  ) => void;
  downloadHandler: (uri: string, fileName: string) => void;
  deleteHandler: (
    existingTaskData: ITask,
    documentId: number,
    reason: string,
  ) => void;
  taskStateHandler: (taskId: number, state: TaskState, reason?: string) => void;
}) => {
  const evidence = task.evidence;
  const onFileSelection = (files: any, evidenceType: string) => {
    uploadHandler(task, files, evidenceType);
  };

  const onTaskStateChange = async (state: TaskState, reason?: string) => {
    if (state) {
      taskStateHandler(task.id, state, reason);
    }
  };

  return (
    <div data-label={ElementLocators.LOCATOR_REINSTATEMENT_SECTION}>
      <FlexRow id={task.id.toString()} className={styles.Title}>
        <FlexCol className={styles.TitleTaskIcon}>
          <NoraTaskIcon task={task} onTaskStateClick={onTaskStateChange} />
        </FlexCol>
        <FlexCol>
          <TitleSmall>
            {Resource.TASK_TITLE_REINSTATEMENT_APPLICATION}
          </TitleSmall>
        </FlexCol>
        <FlexCol className={styles.CreatedDate}>
          {getFormattedTimestamp(task.retriedAt ?? task.createdAt)}
        </FlexCol>
      </FlexRow>
      {task.state === TaskState.WAIVED && task.waiveReason && (
        <FlexRow className={styles.TaskSubtitle}>
          <strong>{Resource.WAIVE_REASON}:</strong>&nbsp;{task.waiveReason}
        </FlexRow>
      )}
      {evidenceExists(evidence) && evidence && (
        <FileDetail
          documents={evidence.documents}
          fileOpenHandler={downloadHandler}
          fileDeletehandler={(documentId: number, reason: string) =>
            deleteHandler(task, documentId, reason)
          }
        />
      )}
      {task.state !== TaskState.COMPLETED &&
        task.state !== TaskState.REQUESTED && (
          <FileUpload
            leftItem={
              evidenceExists(evidence) ? '' : Resource.REINSTATEMENT_APPLICATION
            }
            selectedFiles={onFileSelection}
            type={DocumentType.REINSTATEMENT_APPLICATION}
            ongoingUpload={
              task.ongoingUpload?.[DocumentType.REINSTATEMENT_APPLICATION]
            }
            multiple={false}
          />
        )}
    </div>
  );
};
